import React, { Component } from 'react';
import Login from './../login/login';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './css/index.scss';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import SearchResults from './../searchResults/searchResults';
import OutsideClickHandler from 'react-outside-click-handler';

class Header extends Component {
  
  constructor(props){
    super(props);
    this.state = {
      authenticated: this.props.authenticated,
      showLogin: false,
      term: ''
    };
  }

  componentDidMount(){
    if(this.props.authenticated === true)
    {
      if(this.props.active === 'login')
      {
          this.props.history.push('/');
      }
      if(this.props.active === 'register')
      {
          this.props.history.push('/');
      }
      this.props.getProfile();
    }
  }

  toggleSideMenu = () => {
    if(this.props.sideMenuOpened === false)
    {
      this.props.toggleSideMenu();
    }
  }

  hideLogin = () => {
    this.setState({showLogin: false});
  }

  search = (e) => {
    let term = e.target.value;
    this.setState({term}, () => {
      if(term.length > 0)
      {
        this.apiSearch(this.state.term);
      }
      if(term.length === 0)
      {
        this.props.clearSearch();
      }
    })
  }

  apiSearch = _.debounce((e) => {
    this.props.searchTab(e); 
  }, 300)

  getArtists = () => {
    return this.props.searchResults.artists.map((artist) => {
        return <Link className="resultLink" to={`/artist/${artist.slug}`}>{artist.name}</Link>
    });
  }

  getTabs = () => {
    return this.props.searchResults.tabs.map((tab) => {
        return <Link className="resultLink" to={`/tabulatura/${tab.id}/${tab.artist.name}/${tab.title}`}>{tab.title}</Link>
    });
  }

  render () {
    return (
      <OutsideClickHandler
            onOutsideClick={() => {
                this.setState({term: ''}, () => {
                  this.props.clearSearch();
                });
            }}
        >
        <div>
        <header className="navbar">
          <div className="logo-container" onClick={()=> { this.props.history.push('/') }}>
            <div className="logo"></div>
            <div className="title">taburi</div>
          </div>
          <div className="srch">
            <input className="taburi-search" placeholder="Caută tabulatură" type="text" value={this.state.term} onChange={this.search} />
          </div>
          <div className="account-bar">
            {this.props.authenticated === true ? 
            <div className="userProfileNameHello">
              Bună {this.props.profile !== null ? this.props.profile.name : null}!
            </div>
            :
            (this.props.active !== 'login' ? (
              <div>
                <span onClick={()=>{ if(this.state.showLogin === false){
                  this.setState({showLogin: !this.state.showLogin});
                }}}>
                Autentificare <FontAwesomeIcon style={{marginLeft: '10px'}} icon="user" />
                </span>
                {this.state.showLogin === true ? (<Login hideLogin={this.hideLogin}  />) : null}
              </div>
            ) : <div></div>)
            }
          </div>

          <div onClick={this.toggleSideMenu} style={{marginRight: '20px', cursor: 'pointer'}}>
            <FontAwesomeIcon style={{height: '40px', fontSize: '24px'}} icon="bars" />
          </div>
            
        </header>
        {(this.props.searchResults.tabs !== undefined || this.props.searchResults.artists !== undefined) ? 
        (
          <SearchResults clearSearch={this.props.clearSearch} searchResults={this.props.searchResults} />
        )
        :
        <div></div>}
        </div> 
        </OutsideClickHandler>
    );
  }
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js